import {useAccessPayConfiguration, useMutationWithErrorHandling, usePost} from '@app/sdk';

export function useAddArudReport() {
  const post = usePost();
  const { data: accessPayConfig } = useAccessPayConfiguration();

  async function addArudReport(data: {
    reasonCode: string;
    accountNumber: string;
    customerName: string;
    sortCode: string;
    bankAccountNumber: string;
    reasonDescription: string;
    amount: number;
    originalProcessingDate: Date;
    serviceUserNumber: string;
  }) {
    const request = {
      ReturnedDebitItems: [
        {
          PayerName: data.customerName,
          Reference: data.accountNumber,
          ReturnCode: data.reasonCode,
          ReturnDescription: data.reasonDescription,
          Amount: data.amount,
          BankAccountNumber: data.bankAccountNumber,
          SortCode: data.sortCode,
          originalProcessingDate: data.originalProcessingDate,
        },
      ],
      serviceUserNumber: data.serviceUserNumber
    };
    return await post(`${accessPayConfig?.baseUrl}/debug/reports/arudd`, request);
  }

  return useMutationWithErrorHandling({
    mutationFn: addArudReport,
  });
}
